export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">联系我们</h2>
          <p className="text-foreground-500 text-sm mt-2">有任何问题或建议？欢迎通过以下方式与我们取得联系</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-background-100 rounded-xl p-6 border border-background-300/30 text-center cursor-pointer hover:border-primary-500/30 transition-all duration-300 group">
            <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-500/20 transition-colors">
              <i className="ri-mail-line text-primary-400 text-xl"></i>
            </div>
            <h3 className="text-foreground-100 font-bold text-sm mb-1">商务合作</h3>
            <p className="text-foreground-600 text-xs">business@juzicinema.com</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 border border-background-300/30 text-center cursor-pointer hover:border-accent-500/30 transition-all duration-300 group">
            <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-accent-500/20 transition-colors">
              <i className="ri-service-line text-accent-400 text-xl"></i>
            </div>
            <h3 className="text-foreground-100 font-bold text-sm mb-1">用户反馈</h3>
            <p className="text-foreground-600 text-xs">feedback@juzicinema.com</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 border border-background-300/30 text-center cursor-pointer hover:border-secondary-500/30 transition-all duration-300 group">
            <div className="w-12 h-12 rounded-xl bg-secondary-500/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-secondary-500/20 transition-colors">
              <i className="ri-team-line text-secondary-700 text-xl"></i>
            </div>
            <h3 className="text-foreground-100 font-bold text-sm mb-1">加入我们</h3>
            <p className="text-foreground-600 text-xs">hr@juzicinema.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}